import { formatNumber } from 'App/utils';
import { Text as ChartText } from 'recharts';

export const TickYAxis = ({ payload: { value }, width, x, y, unitMass }: any) => (
  <ChartText textAnchor='end' width={width} x={x} y={y}>
    {`${formatNumber(value)} ${unitMass}`}
  </ChartText>
);
